import { __extends } from 'tslib';
import classNames from 'classnames';
import * as React from 'react';
import { t } from '../../localization.js';
import Tooltip from '../Tooltip/Tooltip.js';
import TooltipBody from '../Tooltip/TooltipBody.js';
import TooltipDecoratorClass from '../Tooltip/TooltipDecorator.js';
import styles from './HiddenStatisticsIcon.module.scss.js';

var Icon = function (props) { return React.createElement("i", { className: props.className }); };
var IconWithTooltip = TooltipDecoratorClass()(Icon);
var HiddenStatisticsIcon = (function (_super) {
    __extends(HiddenStatisticsIcon, _super);
    function HiddenStatisticsIcon(props) {
        return _super.call(this, props) || this;
    }
    HiddenStatisticsIcon.prototype.renderToolip = function () {
        if (this.props.disableTooltip)
            return null;
        var content = null;
        if (this.props.isClan) {
            content = (React.createElement(TooltipBody, null, t('Статистика клана скрыта, так как в клане только один игрок, и он скрыл свою статистику:тултип')));
        }
        else {
            content = this.props.isOwnAccount ? (React.createElement(TooltipBody, null,
                React.createElement("p", null, t('Ваша статистика скрыта:тултип статистика скрыта текущего игрока строка 1')),
                React.createElement("p", null, t('Количество добытых баррелей нефти остаётся доступным для просмотра командующему и заместителям командующего.:тултип статистика скрыта текущего игрока строка 2')))) : (React.createElement(TooltipBody, null, t('Статистика скрыта:тултип')));
        }
        return React.createElement(Tooltip, null, content);
    };
    HiddenStatisticsIcon.prototype.render = function () {
        var _a;
        var classNameIcon = classNames(styles.icon, (_a = {},
            _a[styles.isLarger] = this.props.isLarger,
            _a), this.props.className);
        return React.createElement(IconWithTooltip, { className: classNameIcon, tooltipBody: this.renderToolip() });
    };
    return HiddenStatisticsIcon;
}(React.PureComponent));

export { HiddenStatisticsIcon as default };
//# sourceMappingURL=HiddenStatisticsIcon.js.map
